import { css } from 'emotion'
import { Colors, SliderLabel, Easings } from './..'

export const ProductStyle = (max, ready, active, hasPdf) => css({
  position: 'relative',
  height: '100%',
  width: '100%',
  opacity: ready ? 1 : 0,
 
  transition: 'all 1000ms ease 400ms',
  '@media (min-width: 1024px)': {
    height: 'calc(100vh - 160px)',
  },
  '.product': {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 120px)',
    '@media (min-width: 1024px)': {
      height: 'calc(100vh - 160px)',
    },
  },
  '.product-template': {
    height: 'calc(100vh - 120px)',
    '@media (min-width: 1024px)': {
      height: 'calc(100vh - 160px)',
    },
  },
  '.product-nav': {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '60px',
    borderTop: `1px solid ${Colors.extraLightGrey}`,
    zIndex: 3,
    background: 'white',
    '@media (min-width: 1024px)': {
      height: '80px',
    },
    '.btn-return': {
      borderRight: `1px solid ${Colors.extraLightGrey}`,
    },
    '.btn-bookmark': {
      borderRight: '1px solid white',
    },
    '.btn': {
      height: 60,
      lineHeight: '60px',
      width: 60,
      'svg': {
        verticalAlign: 'middle'    ,
      },
      '@media (min-width: 1024px)': {
        height: '80px',
        lineHeight: '80px',
        width: 80,
      },
    },
    '.pdf-annotation': {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: '1rem',
      transform: 'translateY(-125%)',
      opacity: 1,
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      //animation: 'fadeIn 300ms ease forwards',
      //animationDelay: '3000ms',
      display: 'none',
      fontSize: '0.9375rem',

      'span': {
        maxWidth: '210px',
        textAlign: 'center',
      },
      '@media (min-width: 1024px)': {
        display: 'flex'
      },
      'svg' : {
        marginLeft: '5px',
      }
    },
    '@keyframes fadeIn': {
      '0%': {
        opacity: 1,
        transform: 'translateY(-125%)'
      },
      '100%': {
        opacity: 0,
        transform: 'translateY(-100%)'
      }
    },
    '.nav': {
      position: 'relative',
      maxWidth: hasPdf ? 'calc(100% - 180px)' : 'calc(100% - 120px)',
      flexBasis: hasPdf ? 'calc(100% - 180px)' : 'calc(100% - 120px)',
      padding: '0 10px',
      '@media (min-width: 1024px)': {
        maxWidth: hasPdf ? 'calc(100% - 240px)' : 'calc(100% - 160px)',
        flexBasis: hasPdf ? 'calc(100% - 240px)' : 'calc(100% - 160px)',
        padding: 0,
        '&:after': {
          content: "''",
          position: 'absolute',
          bottom: 0,
          left: 0,
          height: 4,
          background: 'black',
          width: '100%',
          transition: 'transform 400ms ease',
          zIndex: 10,
          transform: `scaleX(${active/max})`,
          transformOrigin: 'center left',
        }
      },
      'li': {
        position: 'relative',
        cursor: 'pointer',
        width: 8,
        color: Colors.grey,
        height: 60,
        lineHeight: '60px',
        margin: '0 6px',
        fontSize: '0.8375rem',
        transition: 'color 200ms ease',
        '&:hover': {
          color: 'black',
        },
        '@media (min-width: 1024px)': {
          ...SliderLabel,
          textTransform: "none",
          height: 80,
          lineHeight: '80px',
          maxWidth: `calc(1/${max} * 100%)`,
          flexBasis: `calc(1/${max} * 100%)`,
          textAlign: 'center',
          margin: 0,
         
        },
        'span': {
          display: 'inline-block',
          verticalAlign: 'middle',
          lineHeight: 1.2,
          position: 'absolute',
          top: '20%',
          whiteSpace: 'nowrap',
          opacity: 0,
          left: 0,
          textTransform: 'uppercase',
          '&.reverse': {
            right: 0,
            left: 'auto',
          },
          '@media (min-width: 1024px)': {
            position: 'relative',
            top: 0,
            whiteSpace: 'normal',
            opacity: 1,
            left: 0,
            transform: 'none',
          }
        },
        '&:after': {
          content: '""',
          width: 8,
          height: 8,
          borderRadius: 9999,
          position: 'absolute',
          left: 0,
          top: '60%',
          background: Colors.lightGrey,
          '@media (min-width: 1024px)': {
            display: 'none',
          },
        },
        '&.active': {
          color: 'black',
          'span': {
            opacity: 1,
          },
          '&:after': {
            background: Colors.darkGrey,
            '@media (min-width: 1024px)': {
              transform: 'scaleX(1)',
            }
          }
        }
      }
    }
  },
  '.product-slider': {
    height: '100%',
    width: '100%',
  },
  '.flickity': {
    '&-viewport':{
      '@media (max-width: 1023px)': {
        overflow: 'hidden',
      }
    },
    '&-slider': {
      height: '100%',
      width: '100%',
      transform: 'none !important',
    },
    '&-slide': {
      opacity: 0,
      transition: 'all 0ms ease',
      height: '100%',
      width: '100%',
      top: 0,
      left: '0 !important',
      zIndex: 0,
      transitionDelay: '600ms',
      overflow: 'hidden',
      '&:first-child':{
        position: 'relative !important',
        zIndex: 1,
      },
      '.template-content':{
        opacity: 0,
        transform: 'translateY(10px)',
        transition: `all 400ms ${Easings.customEase}`,
      },
      '.template-bgd': {
        opacity: 0,
        transition: `all 400ms ${Easings.customEase}`,
      },
      '.template-picture': {
        '&:before': {
          content:'""',
          position:'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'white',
          zIndex: 10,
          transition: `all 400ms ${Easings.customEase}`,
          transformOrigin: 'center right',
          transform: 'scaleX(1)',
        },
        '&--top': {
          backgroundPosition: 'center top',
        },
        '&--center': {
          backgroundPosition: 'center center',
        },
        '&--bottom': {
          backgroundPosition: 'center bottom',
        }
      },
      '&.is-selected, &[aria-selected="true"]': {
        opacity: 1,
        zIndex: 2,
        overflow: 'visible',
        '.template-content':{
          opacity: 1,
          transform: 'translateY(0px)',
          transitionDelay: '600ms',
        },
        '.template-bgd': {
          opacity: 1,
          transitionDelay: '500ms',
        },
        '&.template-picture, .template-scroll > .template-picture': {
          '&:before': {
            transform: 'scaleX(0)',
            transitionDelay: '600ms',
          }
        }
       
      }
    },
    
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/product.js